import Initials from './Initials';

export default Initials;
